export interface Document {
  id: string;
  name: string;
  type: string;
  date: string;
  size: string;
  format: string;
  category: string;
  path: string;
  dueDate?: string | null;
  noticeDate?: string | null;
  uploadedBy?: string | null;
}

export const defaultDocumentTypes = [
  { id: 1, type: 'Contratos y proveedores' },
  { id: 2, type: 'Documentación financiera' },
  { id: 3, type: 'Informes técnicos' },
  { id: 4, type: 'Normativas y legislación' },
  { id: 5, type: 'Pólizas de seguro' },
];

export const defaultCategories = defaultDocumentTypes.map(category => String(category.id));

export const categoryNames: Record<string, string> = Object.fromEntries(
  defaultDocumentTypes.map(category => [String(category.id), category.type])
);
